module.exports = __webpack_public_path__ + "static/media/default-monochrome.c5ff48ef.svg";